import { today, last2, last3 } from '@/store/helpers'

export const configColumn = [
  {
    key: 'pickup_date',
    label: 'Pengajuan',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',

  },
  {
    key: 'pic_name',
    label: 'Nama User',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      minWidth: '200px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'order_total',
    label: 'Jumlah Paket',
    class: 'p-1 align-middle text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'cnote',
    label: 'Resi Sample',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'city',
    label: 'Kota Jemput',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'delay',
    label: 'Delay Pickup',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
]

export const dateRange = {
  startDate: last2,
  endDate: last2,
}

export const locale = {
  format: 'dd/mm/yyyy',
}

const last11 = new Date(today)
last11.setDate(today.getDate() - 10)

const last8 = new Date(today)
last8.setDate(today.getDate() - 8)

const lusa = new Date(today)
lusa.setDate(today.getDate() + 3)

export const ranges = {
  'Hari Kemarin': [last2, last2],
  '3 Hari Terakhir': [last3, today],
  'Custom ': [last11, last8],
}

// Constants untuk validasi
export const MAX_DAYS_SELECTION = 3
export const MAX_RANGE_DAYS = 10
export const DATE_RANGE_MIN = last11
export const DATE_RANGE_MAX = lusa
